import dayjs from 'dayjs';

import { ICustomer } from 'models/customer.model';
import { Transporter } from 'models/transporter.model';
import { IPaymentTransaction } from 'models/payment-transaction.model';
import { InvoiceStatusEnum } from './enums/invoice-status.enum';
import { BasketOrderStatus, LIST_BASKET_ORDER_STATUS } from './basket-order-status.model';
import { LIST_PAYMENT_METHOD, PaymentMethod } from './payment-method.model';

export class BasketOrder {
  public id?: number;
  public status: InvoiceStatusEnum | BasketOrderStatus;
  public priceHt?: number;
  public transportPrice?: number;
  public insurance?: number;
  public vat?: number;
  public price?: number;
  public totalPallets?: number;
  public totalParcels?: number;
  public totalUms?: number;
  public billDate?: dayjs.Dayjs;
  public billAddressFullname?: string;
  public billAddressStreetNumber?: string;
  public billAddressStreet?: string;
  public billAddressZipCode?: string;
  public billAddressCity?: string;
  public billAddressCountry?: string;
  public billAddressAdditionals?: string;
  public vatNumber?: string;
  public carbonFootprint?: number;
  public totalWeight?: number;
  public dueDate?: dayjs.Dayjs;
  public gazoleTaxRate?: number;
  public gazoleTaxCurrentValue?: number;
  public gazoleTaxReferenceValue?: number;
  public gazoleTax?: number;
  public billNumber?: string;
  public paymentMethod: string | PaymentMethod;
  public paymentTransactionId?: number;
  public billStorage?: string;
  public totalVolume?: number;
  public billingQuantity?: number;
  public paymentCardAlias?: string;
  public incidentAmount?: number;
  public customer?: ICustomer;
  public transporter: Transporter;
  public currentOwner?: ICustomer;
  public paymentTransactions: IPaymentTransaction[] = [];
  public nbRelaunch?: number;

  constructor(data: any = {}) {
    Object.assign(this, data);
    this.billDate = data.billDate ? dayjs(data.billDate) : undefined;
    this.dueDate = data.dueDate ? dayjs(data.dueDate) : undefined;
    this.transporter = data.transporter ? new Transporter(data.transporter) : new Transporter();
    this.status = data.status ? LIST_BASKET_ORDER_STATUS[data.status] : LIST_BASKET_ORDER_STATUS.INIT;
    this.paymentMethod = data.paymentMethod ? LIST_PAYMENT_METHOD[data.paymentMethod] : undefined;
  }
}
